import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Tabs, Tab } from 'react-bootstrap';
import AddUser from './AddUser/index';
import Panel from '../../../../../components/angle/Panel/index';
import Select from '../../../../../components/Select/index';
import Spinner from '../../../../../components/Spinner/index';
import {
    fetchUsers,
    updateUserSelected,
    updateEditUserPayload
} from '../../../../../services/redux/employee/user/actions';

class SignUp extends Component {
    componentDidMount() {
        let { fetchUsers } = this.props;
        fetchUsers();
    }

    componentWillUnmount() {
        let { updateUserSelected } = this.props;
        updateUserSelected({});
    }

    handleUserChange = (name, value) => {
        let { updateUserSelected } = this.props;
        if (value) {
            updateUserSelected(value);
        } else {
            updateUserSelected({});
        }
    };

    onViewClick = () => {
        let { user, updateEditUserPayload, history } = this.props;
        if (user.selectedItemData.email) {
            updateEditUserPayload(user.selectedItemData);
            history.push('/view-user');
        }
    };

    onEditClick = () => {
        let { user, updateEditUserPayload, history } = this.props;
        if (user.selectedItemData.email) {
            updateEditUserPayload(user.selectedItemData);
            history.push('/edit-user');
        }
    };

    render() {
        let { user } = this.props;
        let viewButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onViewClick}
            >
                View
            </button>
        );

        let editButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onEditClick}
            >
                Edit
            </button>
        );

        const buttonList = [viewButton, editButton];

        return (
            <div role="tabpanel" className="panel col-md-6 mb p0">
                <Tabs defaultActiveKey={1} id="tabID" mountOnEnter={true}>
                    <Tab eventKey={1} title="Search Users">
                        <Panel
                            showHeader
                            header="Users"
                            showFooter
                            footerComponents={buttonList}
                        >
                            <div>
                                <Select
                                    placeholder="Choose a User"
                                    name="user"
                                    labelKey="email"
                                    valueKey="email"
                                    selectedValue={user.selectedItemData.email}
                                    onChange={this.handleUserChange}
                                    options={user.users}
                                />
                            </div>
                        </Panel>
                    </Tab>
                    <Tab eventKey={2} title="Add User">
                        <AddUser />
                    </Tab>
                </Tabs>
                {user.fetching && <Spinner />}
            </div>
        );
    }
}
const mapStateToProps = state => ({
    user: state.employee.user
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchUsers,
            updateUserSelected,
            updateEditUserPayload
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(SignUp));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/SignUp/screens/index.js